/**
 * Influencer tier (categoria) types shared by the tier components.
 *
 * Tier definitions (names, benefits, rates) live in the `influencer_tiers`
 * table and are fetched via GET /api/influencers/tier — they are metadata and
 * may change. Only the ids are hardcoded here, for badges/ordering.
 *
 * Tiers do NOT drive commission calculation (see api/lib/commission.js).
 */

export type TierId = "starter" | "oficial" | "elite" | "top5";

export const TIER_IDS: TierId[] = ["starter", "oficial", "elite", "top5"];

export interface InfluencerTier {
  id: TierId;
  name: string;
  description: string | null;
  commission_rate: number;
  min_monthly_sales: number | null;
  benefits: string[];
  sort_order: number;
}

export function isTierId(value: string | null | undefined): value is TierId {
  return !!value && (TIER_IDS as string[]).includes(value);
}
